import { mutations } from '../types';
import { $request } from '../../utils/request';
import { api } from '../../utils/api';
export const actions = {
    login({ dispatch, commit }, data) {
        const url = data.url ?? api.login;
        if (data.url)
            delete data.url;
        return new Promise((resolve, reject) => {
            $request
                .post(url, data)
                .then((res) => {
                if (res?.ret?.code === 200) {
                    commit(mutations.passport.auto, data.remember ?? false);
                    dispatch('user', res.data);
                }
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    logout({ commit }, data) {
        const url = data?.url ?? api.logout;
        return new Promise((resolve, reject) => {
            $request
                .get(url)
                .then((res) => {
                if (res?.ret?.code === 200)
                    commit(mutations.passport.reset);
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    register({}, data) {
        const url = data.url ?? api.register;
        if (data.url)
            delete data.url;
        return new Promise((resolve, reject) => {
            $request
                .post(url, data)
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    binding({ dispatch, commit }, data) {
        const url = `${api.register}/${data.type}`;
        return new Promise((resolve, reject) => {
            $request
                .post(url, data)
                .then((res) => {
                if (res?.ret?.code === 200) {
                    commit(mutations.passport.auto, true);
                    dispatch('user', res.data);
                }
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    authorize({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            $request
                .post(data.url, { token: data.token })
                .then((res) => {
                if (res?.ret?.code === 200) {
                    commit(mutations.passport.auto, true);
                    dispatch('user', res.data);
                }
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    refresh({ commit }, data) {
        const url = data.url ?? api.refresh;
        data.url && delete data.url;
        return new Promise((resolve, reject) => {
            $request
                .post(url, data)
                .then((res) => {
                if (res?.ret?.code === 200) {
                    commit(mutations.passport.token.access, res.data.access_token);
                    commit(mutations.passport.token.refresh, res.data.refresh_token);
                }
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    user({ commit }, data) {
        commit(mutations.passport.user, data.user);
        commit(mutations.passport.token.access, data.tokens.access_token);
        commit(mutations.passport.token.refresh, data.tokens.refresh_token);
    }
};
